module.exports = __webpack_public_path__ + "static/media/Monday_Step6_endcard.a188cdd0.webp";